import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EFormService } from '../../../../shared-components/e-forms/e-form.service';
import { EFormInstance } from '../../../../shared-components/e-forms/e-form-instance.model';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { EFormTemplate } from '../../../../shared-components/e-forms/e-form-template.model';

@AutoUnsubscribe({ includeArrays: true })
@Component({
    selector: 'app-e-form-format-warning',
    templateUrl: './e-form-format-warning.component.html',
    styleUrls: ['./e-form-format-warning.component.css']
})
export class EFormFormatWarningComponent implements OnInit, OnDestroy {

    showDropdownWarning: boolean = false;
    showTextboxWarning: boolean = false;

    constructor(
        private dialogRef: MatDialogRef<EFormFormatWarningComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        if (data) {
            this.showDropdownWarning = data.showDropdownWarning;
            this.showTextboxWarning = data.showTextboxWarning;
        }
    }

    ngOnInit() {

    }

    ngOnDestroy() { }

    continueClick() {
        this.dialogRef.close(true);
    }

    cancelClick() {
        this.dialogRef.close(false);
    }

}
